import { CreateDraftResponse } from '@cemex-core/cmx-api/models/drafts/responses/create-draft-response';
import { OneClickProfileActions, OneClickProfileActionTypes } from '../actions/one-click-profile.actions';
import { Order } from '@cemex-core/cmx-api';
import { Prices } from '@ordersnproducts/modules/one-click-order/models/prices';

export interface OneClickProfileState {
  loading: boolean;
  result: CreateDraftResponse;
  presetOrder: Order;
  isEditMode: boolean;
  prices: Prices;
  blockedPrices: boolean;
}

export const initialState: OneClickProfileState = {
  loading: false,
  result: null,
  presetOrder: null,
  isEditMode: false,
  prices: null,
  blockedPrices: false,
};

export function reducer(state = initialState, action: OneClickProfileActions): OneClickProfileState {
  switch (action.type) {
    case OneClickProfileActionTypes.CREATE_PROFILE: {
      return {
        ...state,
        loading: true,
      } as OneClickProfileState;
    }
    case OneClickProfileActionTypes.UPDATE_PROFILE: {
      return {
        ...state,
        loading: true,
      } as OneClickProfileState;
    }
    case OneClickProfileActionTypes.CREATE_PROFILE_COMPLETED: {
      return {
        ...state,
        loading: false,
        result: action.payload,
      } as OneClickProfileState;
    }
    case OneClickProfileActionTypes.LOAD_PROFILE_DETAIL: {
      return {
        ...state,
        loading: true,
        presetOrder: null,
        isEditMode: true,
      } as OneClickProfileState;
    }
    case OneClickProfileActionTypes.LOAD_PROFILE_DETAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        presetOrder: action.payload,
      };
    }
    case OneClickProfileActionTypes.LOAD_PROFILE_PRICES: {
      return {
        ...state,
        prices: {
          ...state.prices,
          loadingPrices: true,
        },
      } as OneClickProfileState;
    }
    case OneClickProfileActionTypes.LOAD_PROFILE_DETAIL_ERROR:
    case OneClickProfileActionTypes.LOAD_PROFILE_PRICES_ERROR:
    case OneClickProfileActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    case OneClickProfileActionTypes.LOAD_PROFILE_PRICES_COMPLETE: {
      return {
        ...state,
        loadingPrices: false,
        prices: action.payload,
      } as OneClickProfileState;
    }
    case OneClickProfileActionTypes.SET_PROFILE_PRICES_BLOCKED: {
      return {
        ...state,
        blockedPrices: action.payload,
      } as OneClickProfileState;
    }
    case OneClickProfileActionTypes.RESET_PRICES: {
      return {
        ...state,
        blockedPrices: initialState.blockedPrices,
        prices: initialState.prices,
      } as OneClickProfileState;
    }
    default: {
      return state;
    }
  }
}
